import NotesBook from '@berlitz/streamline-icons/lib/regular/11-Content/03-Notes/NotesBook'
import ELearningBookLaptop from '@berlitz/streamline-icons/lib/regular/36-School-Learning/03-E-Learning/ELearningBookLaptop'
import PortalLearningPath from '@classes/LearningPath'
import Tooltip from '@components/Tooltip'
import {
  CollapseTitleGroup,
  HeaderIconsGroup,
  IconBadge,
  IconBadgeContainer,
  LangBadge,
} from '@layouts/LearningPath/Layout/style'
import React from 'react'
import { useIntl } from 'react-intl'

const CollapseHeader: React.FC<{
  title: string
  language?: string
  materialType?: string
  isFlex?: boolean
  isElective?: boolean
  path?: PortalLearningPath
  isSkillTutorPath?: boolean
  isIndustrySpecific?: boolean
  level?: string
}> = ({ title, language, materialType, isFlex, path, isElective, isSkillTutorPath, isIndustrySpecific, level }) => {

  const intl = useIntl()

  const firstLevel = path?.Level?.[0] ?? 0
  const levelPill = firstLevel < 5 ? 'Basic' : 'Intermediate'

  const skillsTutorLevelPill = isSkillTutorPath ? (level ?? (firstLevel ? levelPill : undefined)) : undefined

  return (
    <div>
      <CollapseTitleGroup>
        <span>{title}</span>
        {!!(path?.IsElective || isElective) && <LangBadge>{intl.formatMessage({ id: 'Elective' })}</LangBadge>}
        {!!path?.IsFoundation && !isSkillTutorPath && (
          <LangBadge>{intl.formatMessage({ id: 'Foundational' })}</LangBadge>
        )}
        {skillsTutorLevelPill && <LangBadge>{intl.formatMessage({ id: skillsTutorLevelPill })}</LangBadge>}
        {isIndustrySpecific && levelPill && <LangBadge>{intl.formatMessage({ id: levelPill })}</LangBadge>}
        {language && <LangBadge>{language}</LangBadge>}
      </CollapseTitleGroup>
      <HeaderIconsGroup>
        {materialType?.includes('digital') && !isFlex && (
          <IconBadgeContainer>
            <Tooltip message={intl.formatMessage({ id: 'Digital Material' })}>
              <IconBadge>
                <ELearningBookLaptop color="brandSupporting01" />
              </IconBadge>
            </Tooltip>
          </IconBadgeContainer>
        )}
        {materialType?.includes('print') && !isFlex && (
          <IconBadgeContainer>
            <Tooltip message={intl.formatMessage({ id: 'Printed Material' })}>
              <IconBadge>
                <NotesBook color="brandSupporting01" />
              </IconBadge>
            </Tooltip>
          </IconBadgeContainer>
        )}
      </HeaderIconsGroup>
    </div>
  )
}

export default CollapseHeader
